module.exports = __webpack_public_path__ + "static/media/bandeira-us.98258216.png";